import ContactNom from '@/generated/controls/contact/ContactNom.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: ContactNom
})
